// extracted by mini-css-extract-plugin
export default {"bonusCollectWrap":"styles_bonusCollectWrap__fCItl","bonusCollectImg":"styles_bonusCollectImg__Wffkm","button":"styles_button__Vl2mw"};